const translations = {
  "en": {
    "Performance": "Performance",
    "The chart will be updated the next day.": "The chart will be updated the next day."
  },
  "zh-tw": {
    "Performance": "投資表現",
    "The chart will be updated the next day.": "圖表將於次日更新。"
  }
};

export default translations;
